import { createFileRoute } from '@tanstack/react-router';
import { withMemberGate } from '@/lib/with-member-gate';
import { DeckLibrary } from '@/components/halloween/DeckLibrary';

export const Route = createFileRoute('/halloween_/decks')({
  head: () => ({ meta: [
    { title: 'The Five Decks — Recovery Trauma™' },
    { name: 'description', content: 'Browse every card in the mansion’s five reflection decks, with their stories, and draw one whenever you like.' },
    { property: 'og:title', content: 'The Five Decks — Recovery Trauma™' },
    { property: 'og:description', content: 'A candlelit library of the mansion’s five reflection decks. Fictional storytelling, never spirit communication.' },
    { property: 'og:type', content: 'website' },
    { name: 'twitter:card', content: 'summary' },
    { name: 'robots', content: 'noindex, nofollow' },
  ] }),
  component: withMemberGate(DeckLibrary, 'Mansion Decks'),
});
